import { useCallback, useEffect, useState } from 'react'

export const useExtensionShadowDom = () => {
  const [shadowDom, setShadowDom] = useState<HTMLElement | null>(null)

  const findShadowDomWithin3Seconds = useCallback((retryTimes = 10) => {
    const shadowDomElement = document.querySelector('grammarly-assistant-notch-view') as HTMLElement
    const isDomReady = shadowDomElement?.shadowRoot?.querySelector(
      '[aria-label=grammarly-global-assistant-notch]',
    )

    if (!isDomReady) {
      if (retryTimes > 0) {
        return setTimeout(() => {
          findShadowDomWithin3Seconds(retryTimes - 1)
        }, 300)
      }
      return
    }

    setShadowDom(shadowDomElement)
  }, [])

  useEffect(() => {
    const timeout = findShadowDomWithin3Seconds()
    return () => clearTimeout(timeout)
  }, [findShadowDomWithin3Seconds])

  return shadowDom
}
